export const HeaderLang = {

    //top header
    CONTACT1: '+91 96967 55555',
    CONTACT2: '+91 75748 55511',
    EMAIL_VALUE: 'lutonceramic@gmail.com',

    //Header
    HOME: 'Home',
    ABOUT_US: 'About Us',
    WHO_WE_ARE: 'Who We Are',
    TECHNICAL_SPECIFICATION: 'Technical Specification',
    COLLECTION: 'Collections',
    CATALOGUE: 'Catalogue',
    CATALOGUE_400X400: '400x400mm',
    CATALOGUE_500X500: '500x500mm',
    E_CATALOGUE: 'E - Catalogue',
    CONTACT_US: 'Contact Us',
    INFRASTRUCTURE: 'Infrastructure',
    EXPORT: 'Export',
};